import React, { PureComponent } from "react"
import classNames from "classnames"

import "./founder-motivational-callout.scss"

const DAY_MS = 24 * 60 * 60 * 1000

function relativeAttribution(iso) {
  if (!iso) return null
  const days = Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / DAY_MS))
  if (days === 0) return "from your check-in today"
  if (days === 1) return "from your check-in yesterday"
  if (days < 14) return `from your check-in ${days} days ago`
  if (days < 56) return `from your check-in ${Math.round(days / 7)} weeks ago`
  return `from your check-in ${Math.round(days / 30)} months ago`
}

class FounderMotivationalCallout extends PureComponent {
  handleClick = (e) => {
    if (this.props.onShowHistory) {
      this.props.onShowHistory()
    }
  }

  handleKey = (e) => {
    if (!this.props.onShowHistory) return
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault()
      this.props.onShowHistory()
    }
  }

  render() {
    const { fa, onShowHistory } = this.props
    if (!fa) return null
    const statement = fa.lastMotivationalStatement
    if (!statement || !statement.trim()) return null

    const attribution = relativeAttribution(fa.lastCheckinAt)
    const interactive = Boolean(onShowHistory)

    return (
      <aside
        className={classNames("founder-motivational-callout", {
          "founder-motivational-callout--interactive": interactive,
        })}
        aria-label="Recent focus"
        role={interactive ? "button" : undefined}
        tabIndex={interactive ? 0 : undefined}
        onClick={interactive ? this.handleClick : undefined}
        onKeyDown={interactive ? this.handleKey : undefined}
      >
        <span className="founder-motivational-callout__eyebrow">
          What to focus on
        </span>
        <blockquote className="founder-motivational-callout__quote">
          {statement}
        </blockquote>
        <div className="founder-motivational-callout__footer">
          {attribution && (
            <span className="founder-motivational-callout__attribution">
              — {attribution}
            </span>
          )}
          {interactive && (
            <span className="founder-motivational-callout__cta">
              View check-in →
            </span>
          )}
        </div>
      </aside>
    )
  }
}

export default FounderMotivationalCallout
